import { Spinner } from 'construct-ui';
import SingleSelectCommonComponentView from '../../../components/common/single-select-common-component.view';
import { messageComponent } from '../../../components/message/message.component';
import udfManagementModel from '../../../models/udf-management/udf-management.modal';
import ViewBase from '../../view-base.view';
import UDFSortableListView from '../udf-management/udf-sortable-list.view';

export default function UDFManagementAddEditView() {
  ViewBase.call(this);

  let inputDatails = { ddlFieldtype: { code: "", name: "" }, udfId: "0", attributeName: "", attributeType: "", description: "", active: "Y", datValueList: [], fieldTypeList: [], dtValues: "", dataValue: "" };
  let columnSeperator = "╠═";
  let rowSeperator = "╚╗";
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let isLoading = false;
  let isDropDown = false;
  let selectedItem;
  let isOnlyList = false;

  let onClose = (needRefresh, result) => { };

  let _loadFieldTypeListList = () => {
    udfManagementModel.getFieldTypeList(
      _fieldListSuccessCallBack,
      _fieldListErrorCallBack
    )
  }

  let _fieldListSuccessCallBack = (result) => {
    inputDatails.fieldTypeList = result;
    if (inputDatails.attributeType != '') {
      let newarrArr = inputDatails.fieldTypeList.filter(x => x.code == inputDatails.attributeType);
      inputDatails.ddlFieldtype = { code: newarrArr[0].code, name: newarrArr[0].name };
    }
    else {
      inputDatails.ddlFieldtype = { code: "", name: "" };
    }
    this.hideLoading();
  }

  let _fieldListErrorCallBack = (error) => {
    this.hideLoading();
    this.handleError(error);
  }

  let _submit = () => {
    isLoading = true;
    udfManagementModel.submitUDFUserData(
      _submitSuccessCallBack,
      _submitErrorCallBack,
      inputDatails
    )
  }

  let _submitSuccessCallBack = (result) => {
    isLoading = false;
    onClose(true, result);
  }

  let _submitErrorCallBack = (error) => {
    isLoading = false;
    this.handleError(error);
  }

  let setAttributeName = (e) => {
    inputDatails.attributeName = e.target.value
  }

  let setDescription = (e) => {
    inputDatails.description = e.target.value
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }

  let _cancel = () => {
    onClose(false, null);
  }

  let addValues = () => {
    let seqArr = inputDatails.datValueList.map(function (o) { return o.sequence; });
    inputDatails.datValueList.push({
      value: "",
      inUse: 'Y',
      sequence: (seqArr.length ? Math.max.apply(Math, seqArr) : 0) + 1
    });
  }

  let _reDrawList = (items) => {
    inputDatails.datValueList = [];
    let newSeq = 1;
    items.forEach(item => {
      let inputList = item.querySelectorAll('input')
      let txtValue = inputList[1].value;
      let inUse = inputList[2].checked;
      inputDatails.datValueList.push({
        value: txtValue,
        inUse: inUse == true ? 'Y' : 'N',
        sequence: newSeq
      });
      newSeq++;
    });
  }

  function onRemove(seq) {
    let newArray = inputDatails.datValueList.filter(function (el) {
      return el.sequence != seq
    });
    inputDatails.datValueList = newArray;
  }

  function onValueChanged(items) {
    _reDrawList(items);
  }

  let _save = () => {
    inputDatails.attributeType = inputDatails.ddlFieldtype.code;
    if (inputDatails.attributeType == '') {
      isMsgOpen = true;
      showMsg = this.getText("EM00000148", "Please select attribute type");
      msgTitle = this.getText("EM00000142", "Error");
      return
    }
    if (inputDatails.attributeType == '002') {
      let items = document.querySelectorAll('#items-list > li');
      let seq = 1;
      let dtValues = "";
      let isAllDataValueEmpty = true;
      items.forEach(item => {
        let inputList = item.querySelectorAll('input')
        let singleValue = "";
        let txtValue = inputList[1].value;
        let inUse = inputList[2].checked ? 'Y' : 'N';
        singleValue = txtValue + columnSeperator + inUse + columnSeperator + seq + rowSeperator;
        dtValues = dtValues + singleValue;
        seq++;
        if (txtValue) {
          isAllDataValueEmpty = false
        }
      });
      if (isAllDataValueEmpty) {
        isMsgOpen = true;
        showMsg = this.getText("", "Please input Data Value");
        msgTitle = this.getText("EM00000142", "Error");
        return
      }
      inputDatails.dtValues = dtValues;
    }
    _submit();
  }

  let _innitializeComponent = (item) => {
    this.showLoading();
    if (item != null) {
      inputDatails.attributeName = item[0].attributeName;
      inputDatails.attributeType = item[0].attributeTypeCode;
      inputDatails.active = item[0].inUse;
      inputDatails.description = item[0].description;
      inputDatails.udfId = item[0].udfid;
      inputDatails.dataValue = item[0].udfData;
      if (inputDatails.attributeType == '002') {
        udfManagementModel.getDetailList(
          (result) => {

            _setDetails(result, item[0].attributeTypeCode);
            _loadFieldTypeListList();
          }, (error) => {
            isMsgOpen = true;
            showMsg = this.getText("EM00000036", "Fail");
            msgTitle = this.getText("EM00000142", "Error");
            this.hideLoading();
          },
          item[0].udfid,
          '001');
      } else {
        _loadFieldTypeListList();
      }
    } else {
      _loadFieldTypeListList();
    }
  }

  let _setDetails = (items, type) => {
    if (items && Array.isArray(items) && items.length > 0) {
      items.forEach(function (element) {
        let item = {
          udfValueId: element.udfValueId, value: element.udfValue, inUse: element.inUse, sequence: element.sequence
        }
        inputDatails.datValueList.push(item);
      });
    }
    if (type === '002') {
      isDropDown = true;
    } else {
      isDropDown = false;
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.displayData) {
        selectedItem = vnode.attrs.displayData;
      }
      if (vnode.attrs.isOnlyList) {
        isOnlyList = vnode.attrs.isOnlyList;
      }
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      _innitializeComponent(selectedItem);
    },
    view: (vnode) => {
      return [m('div',
        m(Spinner, {
          active: isLoading,
          background: true,
          fill: true,
          size: 'xl',
        }),
        m('.row.d-flex.justify-content-center',
          m('.col-md-12',
            m('.card',
              m('.card-header.border-0.pt-2'),
              !isOnlyList && m('.card-body.pt-0.card-min-height',
                m('form',
                  m('.row mb-3',
                    m('label.col-sm-3.col-form-label.text-sm-end', this.getText("LT00000011", "Name")),
                    m('.col-sm-8',
                      m("input[type='text']", {
                        "class": "form-control form-control-bg",
                        value: inputDatails.attributeName,
                        onchange: setAttributeName
                      })
                    )
                  ),
                  m('.row mb-3',
                    m('label.col-sm-3.col-form-label.text-sm-end', this.getText("LT00000012", "Description")),
                    m('.col-sm-8',
                      m("input[type='text']", {
                        "class": "form-control form-control-bg",
                        value: inputDatails.description,
                        onchange: setDescription
                      })
                    )
                  ),
                  m('.row mb-3',
                    m('label.col-sm-3.col-form-label.text-sm-end', this.getText("LT00000013", "Data Type")),
                    m('.col-sm-8',
                      m(SingleSelectCommonComponentView, {
                        disabled: false, iconList: [], items: inputDatails.fieldTypeList, selectedItem: inputDatails.ddlFieldtype, handleSelect: (selectedItem) => {
                          inputDatails.ddlFieldtype = selectedItem;
                          if (selectedItem.code === "002") {
                            isDropDown = true;
                          } else {
                            isDropDown = false;
                          }
                          inputDatails.dtValues = "";
                        }
                      })
                    )
                  ),
                  m('.row mb-3',
                    m('label.col-sm-3.col-form-label.text-sm-end', this.getText("LT00000025", "Active")),
                    m('.col-sm-8',
                      m('.col-md-2',
                        inputDatails.active == "Y" &&
                        m('label.switcher', m('input[type="checkbox"][checked]',
                          {
                            onchange: e => {
                              inputDatails.active = e.target.checked ? 'Y' : 'N';
                            }
                          }
                        ),
                          m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round')),
                        inputDatails.active == "N" &&
                        m('label.switcher', m('input[type="checkbox"]',
                          {
                            onchange: e => {
                              inputDatails.active = e.target.checked ? 'Y' : 'N';
                            }
                          }
                        ),
                          m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round'))
                      ),
                    )
                  ),
                  isDropDown && m('.row mb-3',
                    m('label.col-md-3.col-form-label.text-sm-end', ""),
                    m('.col-md-9.row',
                      m('.col-md-9',
                        m('label.col-md-3.col-form-label.text-sm-end.margin-left-21', this.getText("LT00000014", "Data Value")),
                        m('label.col-md-9.col-form-label.text-sm-end.margin-left-32', this.getText("LT00000025", "Active"))
                      ),
                      m('.col-md-3', m('button.btn.btn-primary[type=button]', { onclick: addValues }, m('i.bi.bi-plus-circle.me-0'))),
                    )
                  ),
                  isDropDown && m('.row mb-3',
                    m('label.col-sm-3.col-form-label.text-sm-end', ""),
                    m('.col-sm-8',
                      m('.card.card-value-max-height',
                        m('.height_limit-266', m(UDFSortableListView, { onValueChanged: onValueChanged, onRemove: onRemove, valueList: inputDatails.datValueList }))),
                    )
                  )
                )
              ),
              isOnlyList && [
                m('.row.col-md-12.mb-3',
                  m('.col-md-12.row',
                    m('.col-md-11',
                      m('label.col-md-9.offset-md-1.col-form-label.margin-left-42', this.getText("LT00000014", "Data Value")),
                      m('label.col-md-1.col-form-label', this.getText("LT00000025", "Active"))
                    ),
                    m('.col-md-1', m('button.btn.btn-primary', { onclick: addValues }, m('i.bi.bi-plus-circle.me-0'))),
                  )
                ),
                m('.height_limit-420',
                  m(UDFSortableListView, {
                    onValueChanged: onValueChanged,
                    onRemove: onRemove,
                    valueList: inputDatails.datValueList
                  })
                )
              ],
              m('.card-footer',
                m('.col-md-12.gap-2.d-flex.justify-content-end',
                  m("button.btn.btn-primary[type='button']",
                    { onclick: _save },
                    this.getText("LT00000022", "Save")
                  ),
                  m("button.btn.btn-white[type='button']",
                    { onclick: _cancel },
                    this.getText("LT00000021", "Close")
                  )
                )
              )
            )
          )
        ),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
      ), this.getBaseViews()];
    }
  }
}
